import React, { useState, useEffect, useContext, Fragment } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { path } from 'ramda';
import styled from 'styled-components';
import { breakpoints } from '../../_helpers/breakpoints';
import { ContentContext } from '../../_context';
import { FaChevronRight } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation/navigation.scss';
import 'swiper/modules/pagination/pagination.min.css';
import { Navigation, Pagination } from 'swiper';


const Wrapper = styled.div`
    width: 100%;
    /* padding: 20px; */
`;

const Breadcrumb = styled.nav`

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #F6F6F6;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 15px;
  margin-bottom: 20px;
  .loader{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    svg{
      display: flex;
      color: #FFD200!important;
    }
  }
  .elements{
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    .element{
        display: flex;
        flex-direction: row;
        align-items: center;
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      color: #484D63;
      cursor: pointer;
      white-space: nowrap;
      margin-top: 3px;
      margin-bottom: 3px;
      :hover{
        color: #FFC600;
        //text-decoration: underline;
      }
    }
    .chevron-icon{
      display: flex;
      font-size: 13px;
      line-height: 13px;
      margin-left: 10px;
      margin-right: 10px;
    }
  }
  @media ${breakpoints.xs} {

  }
  @media ${breakpoints.sm} {

  }
  @media ${breakpoints.md} {

  }
  @media ${breakpoints.lg} {

  }

`

const Breadcrumb_ = styled.nav`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    margin-bottom: 24px;
    font-size: 14px;

    .breadcrumb-item {
        cursor: pointer;
        color: #DD1D21;
        &:hover {
            text-decoration: underline;
        }
        &.active {
            color: #333;
            cursor: default;
            font-weight: 600;
            &:hover {
                text-decoration: none;
            }
        }
    }
    .separator {
        color: #999;
    }
`;

const GridView = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
`;

const ItemCard = styled.div`
    width: 260px;
    border-radius: 10px;
    border: 1px solid #c2c2c2;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border: 1px solid #FFD200;
    }
    img {
        width: 100%;
        display: block;
    }
    span {
        display: block;
        padding: 8px 10px;
        font-size: 13px;
        font-weight: 600;
        text-align: center;
    }
`;

const MediaGallery = styled.div`
    width: 100%;
    max-width: 400px;
    margin-bottom: 20px;
    border: 1px solid #c2c2c2;
    border-radius: 12px;
    overflow: hidden;
    .media-item {
        width: 100%;
        min-height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ffffff;
        border-radius: 8px;
        overflow: hidden;

        img {
            width: 100%;
            height: auto;
            display: block;
            border-radius: 0;
            margin-bottom: 0;
        }
        video {
            width: 100%;
            display: block;
            max-height: 400px;
            /* background-color: #000000!important; */
        }
        audio {
            width: 100%;
            padding: 20px;
            background: #1a1a1a;
        }
    }

    .swiper {
        border-radius: 8px;
        overflow: hidden;
    }
    .swiper-button-prev,
    .swiper-button-next {
        color: #FFD200;
    }
    .swiper-pagination-bullet-active {
        background: #FFD200;
    }
`;

const ProductDetail = styled.div`
    width: 100%;
    /*max-width: 600px;*/

    img {
        width: 100%;
        max-width: 400px;
        border-radius: 8px;
        margin-bottom: 16px;
        display: block;
    }
    h2 {
        font-size: 26px;
        font-weight: 700;
        margin-bottom: 12px;
    }
    .description {
        font-size: 16px;
        line-height: 1.6;
        white-space: pre-line;
        margin-bottom: 20px;
        color: #555;
    }
    .downloads {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        h3 {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 10px;
        }
        a {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 8px 12px;
            background: #f5f5f5;
            border-radius: 6px;
            text-decoration: none;
            color: #DD1D21;
            font-size: 16px;
            margin-bottom: 8px;
            &:hover {
                background: #eee;
            }
        }
    }
`;

const LibraryContainer = () => {

    const { ecommerce_brands,
            libraryProductIdCTA, 
            setLibraryProductIdCTA } = useContext(ContentContext);
    const history = useHistory();
    const { brandId, categoryId, productId } = useParams();

    const [brands, setBrands] = useState(null);
    const [categories, setCategories] = useState(null);
    const [categoryMap, setCategoryMap] = useState({});
    const [parentMap, setParentMap] = useState({});

    useEffect(() => {
        let cancelled = false;
        const response = ecommerce_brands();
        response.then((res) => {
            if (cancelled) return;
            const brandsData = path(['data', 'single', 'brands'], res)?.filter(b => b.status === 1);
            const categoriesData = path(['data', 'single', 'categories'], res);
            setBrands(brandsData);
            setCategories(categoriesData);

            // Construir mapas de categorías y padres para resolución por ID
            const catMap = {};
            const parMap = {};
            if (categoriesData) {
                categoriesData.forEach(cat => {
                    catMap[cat._id] = cat;
                    if (cat.categories?.length) {
                        cat.categories.forEach(sub => {
                            catMap[sub._id] = sub;
                            parMap[sub._id] = cat._id;
                        });
                    }
                });
            }
            setCategoryMap(catMap);
            setParentMap(parMap);
        });
        return () => { cancelled = true; };
    }, []);

    useEffect(() => {
        if (!libraryProductIdCTA || !brands || !categories) return;

        let targetBrandId = null;
        let targetCategoryId = null;
        let targetProductId = null;

        const resolveBrandId = (brandIds = [], product = null) => {
            const validBrand = brandIds.find(brandIdCandidate =>
                brands.some(brand => brand._id === brandIdCandidate)
            );

            if (validBrand) return validBrand;

            if (product?.brand && brands.some(brand => brand._id === product.brand)) {
                return product.brand;
            }

            if (product?.brands?.length) {
                const productBrand = product.brands.find(brandIdCandidate =>
                    brands.some(brand => brand._id === brandIdCandidate)
                );
                if (productBrand) return productBrand;
            }

            return null;
        };

        for (const category of categories) {
            const directProduct = category.products?.find(product => product._id === libraryProductIdCTA);
            if (directProduct) {
                targetProductId = directProduct._id;
                targetCategoryId = category._id;
                targetBrandId = resolveBrandId(category.brands, directProduct);
                if (targetBrandId) break;
            }

            if (category.categories?.length) {
                for (const subCategory of category.categories) {
                    const subProduct = subCategory.products?.find(product => product._id === libraryProductIdCTA);
                    if (subProduct) {
                        targetProductId = subProduct._id;
                        targetCategoryId = subCategory._id;
                        targetBrandId = resolveBrandId(subCategory.brands?.length ? subCategory.brands : category.brands, subProduct);
                        break;
                    }
                }
            }

            if (targetBrandId && targetCategoryId && targetProductId) break;
        }

        if (targetBrandId && targetCategoryId && targetProductId) {
            history.push(`/biblioteca/${targetBrandId}/${targetCategoryId}/${targetProductId}`);
            setLibraryProductIdCTA(null);
        }
    }, [libraryProductIdCTA, brands, categories, history, setLibraryProductIdCTA]);

    // Resolver objetos actuales desde params de URL
    const currentBrand = brandId ? brands?.find(b => b._id === brandId) : null;
    const currentCategory = categoryId ? categoryMap[categoryId] : null;
    const currentProduct = (productId && currentCategory)
        ? currentCategory.products?.find(p => p._id === productId)
        : null;

    // Handlers de navegación
    const handleBrandClick = (brand) => {
        history.push(`/biblioteca/${brand._id}`);
    };

    const handleCategoryClick = (category) => {
        history.push(`/biblioteca/${brandId}/${category._id}`);
    };

    const handleProductClick = (product) => {
        history.push(`/biblioteca/${brandId}/${categoryId}/${product._id}`);
    };

    const renderBreadcrumb = () => {
        if (!brandId) return null;

        const items = [];

        if (currentBrand) {
            items.push({
                label: currentBrand.name,
                path: `/biblioteca/${brandId}`,
                active: !categoryId,
            });
        }

        // Si la categoría actual es una sub-categoría, incluir el padre en el breadcrumb
        if (categoryId && parentMap[categoryId]) {
            const parentCat = categoryMap[parentMap[categoryId]];
            if (parentCat) {
                items.push({
                    label: parentCat.name,
                    path: `/biblioteca/${brandId}/${parentCat._id}`,
                    active: false,
                });
            }
        }

        if (currentCategory) {
            items.push({
                label: currentCategory.name,
                path: `/biblioteca/${brandId}/${categoryId}`,
                active: !productId,
            });
        }

        if (currentProduct) {
            items.push({
                label: currentProduct.name,
                path: `/biblioteca/${brandId}/${categoryId}/${productId}`,
                active: true,
            });
        }

        return (
            <Breadcrumb>
                <div className='elements'>
                    <div className="element">
                        <span onClick={() => history.push('/biblioteca')} className="breadcrumb-item">
                            Biblioteca
                        </span>
                    </div>
                    {items.map((item, i) => (
                        <div key={i} className="element">
                            <div className='chevron-icon'><FaChevronRight /></div>
                            <span
                                onClick={!item.active ? () => history.push(item.path) : undefined}
                                className={`breadcrumb-item${item.active ? ' active' : ''}`}
                            >
                                {item.label}
                            </span>
                        </div>
                    ))}
                </div>
            </Breadcrumb>
        );
    };

    const renderGridItems = (items, type) => (
        <GridView>
            {items.map(item => {
                const imageUrl = type === 'product'
                    ? item.medias?.find(m => m.media_type === 'image')?.media_url
                    : item.image;
                const handleClick = () => {
                    if (type === 'brand') handleBrandClick(item);
                    else if (type === 'category') handleCategoryClick(item);
                    else if (type === 'product') handleProductClick(item);
                };
                return (
                    <ItemCard key={item._id} onClick={handleClick}>
                        {imageUrl && <img src={imageUrl} alt={item.name} />}
                        {/* <span>{item.name}</span> */}
                    </ItemCard>
                );
            })}
        </GridView>
    );

    const renderMediaItem = (media, index) => {
        switch (media.media_type) {
            case 'image':
                return <img src={media.media_url} alt={media.media_name || `media-${index}`} />;
            case 'video':
                return <video controls src={media.media_url} />;
            case 'audio':
                return <audio controls src={media.media_url} />;
            default:
                return null;
        }
    };

    const renderMediaGallery = (medias) => {
        if (!medias?.length) return null;

        if (medias.length === 1) {
            return (
                <MediaGallery>
                    <div className="media-item">
                        {renderMediaItem(medias[0], 0)}
                    </div>
                </MediaGallery>
            );
        }

        return (
            <MediaGallery>
                <Swiper
                    modules={[Navigation, Pagination]}
                    navigation
                    pagination={{ clickable: true }}
                    spaceBetween={0}
                    slidesPerView={1}
                >
                    {medias.map((media, i) => (
                        <SwiperSlide key={i}>
                            <div className="media-item">
                                {renderMediaItem(media, i)}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </MediaGallery>
        );
    };

    const renderProductDetail = (product) => {
        return (
            <ProductDetail>
                {renderMediaGallery(product.medias)}
                <h2>{product.name}</h2>
                {product.description_short && (
                    <p className="description">{product.description_short}</p>
                )}
                {product.download_links?.length > 0 && (
                    <div className="downloads">
                        <h3>Archivos descargables</h3>
                        {product.download_links.map((link, i) => (
                            <a key={i} href={link.media_url} target="_blank" rel="noopener noreferrer">
                                {link.media_name}
                            </a>
                        ))}
                    </div>
                )}
            </ProductDetail>
        );
    };

    const renderCurrentView = () => {
        // Vista de producto
        if (productId) {
            if (!currentProduct) return <p>{/*Producto no encontrado*/}</p>;
            return renderProductDetail(currentProduct);
        }

        // Vista de categoría / sub-categoría
        if (categoryId) {
            if (!currentCategory) return <p>Cargando...</p>;
            const { categories: subCats, products: catProducts } = currentCategory;
            if (subCats?.length > 0) return renderGridItems(subCats, 'category');
            if (catProducts?.length === 1) return renderProductDetail(catProducts[0]);
            if (catProducts?.length > 1) return renderGridItems(catProducts, 'product');
            return <p>No hay contenido disponible</p>;
        }

        // Vista de categorías de una marca
        if (brandId) {
            if (!brands || !categories) return <p>Cargando...</p>;
            if (!currentBrand) return <p>Marca no encontrada</p>;
            const brandCats = categories.filter(cat =>
                cat.brands?.includes(brandId) && cat.level === 0
            );
            if (!brandCats?.length) return <p>No hay categorías disponibles</p>;
            return renderGridItems(brandCats, 'category');
        }

        // Vista raíz – marcas
        if (brands === null) return <p>Cargando...</p>;
        if (brands.length === 0) return <p>No hay marcas disponibles</p>;
        return renderGridItems(brands, 'brand');
    };

    return (
        <Wrapper>
            {renderBreadcrumb()}
            {renderCurrentView()}
        </Wrapper>
    );
};

export default LibraryContainer;